export class City {
    cityid: number;
    cityname: string;
    stateid: number;
    active: number;
}